import React from 'react';
import { Form, notification, InputNumber } from 'antd';
import { pickBy, isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import i18next from 'i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import FundkyModal from 'Parts/ui/components/FundkyModal';
import FundkyCard from 'Parts/ui/components/FundkyCard';
import FundkyButton from 'Parts/ui/components/FundkyButton';
import TextField from 'Parts/ui/components/fields/TextField';
import AddressField from 'Parts/ui/components/fields/AddressField';
import UnitField from 'Parts/ui/components/fields/UnitField';
import TitleField from 'Parts/ui/components/fields/TitleField';
import CityField from 'Parts/ui/components/fields/CityField';
import ProvinceField from 'Parts/ui/components/fields/ProvinceField';
import PostalCodeField from 'Parts/ui/components/fields/PostalCodeField';
import CountryField from 'Parts/ui/components/fields/CountryFieldContainer';
import OrganizationNameField from 'Parts/ui/components/fields/NameField';
import OrganizationTitleField from 'Parts/ui/components/fields/NameField';
import Plugin from '../../../../Plugin';
import LanguageField from '../../../../../donation/components/fields/LanguageField';
import { getLanguageIdByKey } from "Parts/common/langUtils";

import { isPluginActive } from '../../../../pluginActions';
import { nameFieldValidator } from 'Parts/ui/validations/fieldValidations';

import UserInformationCards_en from './locales/UserInformationCards_en.json';
import UserInformationCards_fr from './locales/UserInformationCards_fr.json';

import './UserInformationCards.less';

class UserInformationCards extends React.Component {
  constructor(props) {
    super(props);

    const { isCorporate, user } = props;
    const profiles = user && user.profiles || null;

    let general;
    let work;

    if (profiles) {
      general = profiles.general ? profiles.general : null;
      work = profiles.work ? profiles.work : null;
    }

    const entity = isCorporate ? work : general;

    this.state = {
      country: (entity && entity.country) || null
    };

    this.modalRef = React.createRef();

    i18next.addResourceBundle('en', 'UserInformationCards', UserInformationCards_en);
    i18next.addResourceBundle('fr', 'UserInformationCards', UserInformationCards_fr);
  }

  // Returns user information as an object
  getUserInformation = () => {
    const { isCorporate, user } = this.props;
    const { profiles } = user;

    let general;
    let work;

    if (profiles) {
      general = profiles.general ? profiles.general : null;
      work = profiles.work ? profiles.work : null;
    }
    const entity = isCorporate ? work : general;

    return {
      country: (entity && entity.country) || null,
      genderId: user.honorificId || null,
      firstName: user.firstName || user.firstName,
      lastName: user.lastName || user.lastName,
      languageId: user.languageId,
      address: (entity && entity.address) || null,
      unit: (entity && entity.unit) || undefined,
      city: (entity && entity.city) || null,
      province: (entity && entity.province) || null,
      postalCode: (entity && entity.postalCode) || null,
      organizationName: (work && work.organization && work.organization.name) || null,
      organizationTitle: (work && work.organization && work.organization.title) || null,
      phone: (entity && entity.phone && entity.phone.number) || null,
      ext: (entity && entity.phone && entity.phone.ext) || null,
    };
  };

  onChangeHandler = value => {
    this.setState({
      country: value
    });
  };

  showModal = e => {
    e.preventDefault();
    this.modalRef.current.getWrappedInstance('FundkyModal').showModal();
  };

  handleUpdateInformation = () => {
    const { form } = this.props;
    const { validateFields, isFieldTouched } = form;
    validateFields({ force: true }, (err, values) => {
      if (!err) {
        const {
          t,
          infos,
          user,
          updateMember,
          updateMemberProfile,
          updateSessionState,
          isCorporate
        } = this.props;

        const updatedValues = pickBy(values, (value, key) => isFieldTouched(key));

        if (!isEmpty(updatedValues)) {
          // MEMBER UPDATE
          const memberValues = (
            updatedValues.gender ||
            updatedValues.firstname ||
            updatedValues.lastname ||
            updatedValues.locale
          )
            ? {
                honorificId: updatedValues.gender || null,
                firstName: updatedValues.firstname || null,
                lastName: updatedValues.lastname || null,
                languageId: updatedValues.locale || null
              }
            : null;

          var isMemberEmpty = isEmpty(memberValues);

          if (!isMemberEmpty) {
            updateMember(memberValues, user.id).then(() => {
              updateSessionState();
            });
          }

          // PROFILE UPDATE
          const organizationValues = (
            isCorporate && (
              updatedValues.organizationName ||
              updatedValues.organizationTitle
            )
          )
            ? {
                organizationName: updatedValues.organizationName,
                organizationTitle: updatedValues.organizationTitle
              }
            : null;

          let country;
          if (updatedValues.postalCode && !updatedValues.country) {
            country = { country: values.country };
          }

          if (updatedValues.number) {
            const number = updatedValues.number.toString();
            if (number.length <= 4) {
              updatedValues.number = number;
            } else
            if (number.length <= 7) {
              updatedValues.number = number.substring(0, 3) + '-' + number.substring(3);
            } else
            if (number.length <= 10) {
              updatedValues.number = number.substring(0, 3) + '-' + number.substring(3, 6) + '-' + number.substring(6);
            } else
            if (number.length > 10) {
              const countryLength = number.length - 10;
              updatedValues.number = number.substring(0, countryLength) + '-' +
                              number.substring(countryLength, countryLength + 3) + '-' +
                              number.substring(countryLength + 3, countryLength + 6) + '-' +
                              number.substring(countryLength + 6);
            } else {
              updatedValues.number = number;
            }
          }

          const profileValues =
            updatedValues.country ||
            updatedValues.address ||
            updatedValues.unit ||
            updatedValues.city ||
            updatedValues.province ||
            updatedValues.province === '' ||
            updatedValues.postalCode ||
            updatedValues.number ||
            updatedValues.ext ||
            organizationValues
              ? {
                  country: updatedValues.country,
                  address: updatedValues.address,
                  unit: updatedValues.unit,
                  city: updatedValues.city,
                  province: updatedValues.province === '' ? null : updatedValues.province,
                  postalCode: updatedValues.postalCode,
                  number: updatedValues.number,
                  ext: updatedValues.ext,
                  ...organizationValues,
                  ...country
                }
              : null;

          if (!isEmpty(profileValues)) {
            const type = isCorporate ? 2 : 1;
            updateMemberProfile(profileValues, user.id, type).then(() => {
              if (isMemberEmpty) {
                notification.success({
                  message: t('API_NOTIFICATIONS:success'),
                  description: t('API_NOTIFICATIONS:modifications-saved')
                });
              }
              updateSessionState();
            });
          }
        }
        this.modalRef.current.getWrappedInstance('FundkyModal').hideModal();
      }
    });
  };

  isProfileComplete = () => {
    const { t, infos, user } = this.props;
    const userInformation = this.getUserInformation();
    const gender = user.honorificId ? t(`gender-${user.honorificId}`) : null;
    const isCorporate = this.props.isCorporate;//infos && infos.type == 2 ? true : false;
    const isProvinceRequired = userInformation.country === 'CA' || userInformation.country === 'US';
    const isProvinceCompleted = !isProvinceRequired ? true : userInformation.city;

    return !isCorporate
      ? userInformation.address &&
        userInformation.city &&
        isProvinceCompleted &&
        userInformation.postalCode &&
        gender &&
        userInformation.phone
          ? true
          : false
      : userInformation.address &&
        userInformation.city &&
        isProvinceCompleted &&
        userInformation.country &&
        userInformation.postalCode &&
        gender &&
        userInformation.phone &&
        userInformation.organizationName &&
        userInformation.organizationTitle
          ? true
          : false;
  };

  unformatPhoneNumber = value => value
    ? value.toString().split('-').join('').split('(').join('').split(')').join('').split('+').join('').split(' ').join('').split('.').join('')
    : value;

  render() {
    const { t, infos, user, userTypeId, locale, form, platform } = this.props;

    const userInformation = this.getUserInformation();
    const gender = user.honorificId ? t(`gender-${user.honorificId}`) : null;

    const isCorporate = this.props.isCorporate;//false;//infos.type == 2 ? true : false;
    const icon = isCorporate ? 'building' : 'home';

    const cardContent = this.isProfileComplete()
      ? <p>
          {!isCorporate
            ? `${gender} ${userInformation.firstName} ${userInformation.lastName}`
            : userInformation.organizationName}
          <br />
          {userInformation.address}
          {userInformation.unit
            ? `, ${userInformation.unit}`
            : null}
          <br />
          {userInformation.city && userInformation.city} {userInformation.province}
          <br />
          {userInformation.postalCode}
          <br />
          {userInformation.phone}{userInformation.ext && ` #${userInformation.ext}` || ''}
          <br /><br />
          {t('preferred-language')}
          <br />
          {t("LANGUAGES:" + userInformation.languageId)}
        </p>
      : <p>
          {t('profile-incomplete')}
          <br />
          <a onClick={this.showModal}>{t('add-address')}</a>
        </p>;

    const modalTitle = isCorporate
      ? t('modal-title-corporate')
      : t('modal-title-general');

    const OrganizationField = isCorporate
      ? <div className="CreateInformationForm__Divider OrgNameTitle">
          <OrganizationNameField
            className="CreateInformationForm__Field"
            form={form}
            initialValue={userInformation.organizationName}
            fieldId="organizationName"
            label={false}
            placeholder={true}
            required={true}
            identity="company"
            maxlength={75}
          />
          <TitleField
              className="CreateInformationForm__Field"
              form={form}
              initialValue={userInformation.genderId}
              fieldFormat="radio"
              label={false}
            />
          <OrganizationTitleField
            className="CreateInformationForm__Field"
            form={form}
            initialValue={userInformation.organizationTitle}
            fieldId="organizationTitle"
            label={false}
            placeholder={true}
            required={true}
            identity="job"
            maxlength={75}
          />
        </div>
      : null;

    const defaultLocale =
      infos && infos.locale ||
      user && user.languageId ||
      getLanguageIdByKey(locale) ||
      undefined;

    return (
      <div id="UserInformationCards" className="UserInformationCards">
        {userTypeId === 1
          ? <div className="TicketsDetailsForm__BuyerInfo--boxes">
              <div className="TicketsDetailsForm__BuyerInfo--box">
                <div className="TicketsDetailsForm__BuyerInfo--box--title">
                  <FontAwesomeIcon icon={['fal', 'user-lock']} />
                  <h3>{t('returning-user')}</h3>
                </div>
                <p>{t('returning-user-desc')}</p>
                <FundkyButton
                  // className=""
                  type="primary"
                  size="large"
                  text={t('log-in')}
                  // action={{ func:  }}
                  // disabled={}
                  onClick={this.props.openLoginModal}
                />
              </div>
              <div className="TicketsDetailsForm__BuyerInfo--box">
                <div className="TicketsDetailsForm__BuyerInfo--box--title">
                  <FontAwesomeIcon icon={['fal', 'user-plus']} />
                  <h3>{t('new-user')}</h3>
                </div>
                <p>{t('new-user-desc')}</p>
                <FundkyButton
                  // className=""
                  type="secondary"
                  size="large"
                  text={t('create-account')}
                  // action={{ func:  }}
                  // disabled={}
                  onClick={this.props.openRegisterModal}
                />
              </div>
            </div>
          : <FundkyCard
              className={`UserCard${this.isProfileComplete() ? ' completed' : ''} no-overflow`}
              title={isCorporate ? t('corporate-address') : t('personal-address')}
              icon={<FontAwesomeIcon icon={['fal', icon]} />}
              action={<a onClick={this.showModal}>{t('edit')}</a>}
              onCardClick={e => this.showModal(e)}
            >
              {cardContent}
            </FundkyCard>
        }

        {/* TODO: come back here before the end
          infos.type !== 3 &&
          infos.taxReceipt &&
          isPluginActive(platform, 'TaxReceipt') &&
          this.props.organization.typeId === 2 && (
            <Plugin name="TaxReceipt" component="GenerationNotice" />
          )*/}

        <FundkyModal
          ref={this.modalRef}
          displayModal={false}
          titleIcon={['fal', icon]}
          title={modalTitle}
          acceptLabel={t('update')}
          acceptAction={this.handleUpdateInformation}
          destroyOnClose={true}
        >
          <Form className="UpdateInformationForm" onSubmit={this.handleModalSubmit}>
            <p>{!isCorporate ? t('personal-update-info') : t('corporate-update-info')}</p>
            <div className="CreateInformationForm__Divider">
              <CountryField
                className="CreateInformationForm__Field"
                form={form}
                initialValue={this.state.country}
                label={false}
                placeholder={true}
                onChangeHandler={this.onChangeHandler}
                required={true}
                identity={isCorporate ? 'company' : 'user'}
                dropdownClassName="overModal"
              />
            </div>



            {OrganizationField}

            {!isCorporate && (
              <React.Fragment>
                <TitleField
                  className=""
                  form={form}
                  initialValue={userInformation.genderId}
                  fieldFormat="radio"
                  label={false}
                />

                <div className="CreateInformationForm__Divider">
                  <TextField
                    className="CreateInformationForm__Field"
                    form={form}
                    fieldId="firstname"
                    initialValue={userInformation.firstName}
                    placeholder={t('FIELDS:first-name')}
                    fieldOptions={{
                      rules: [...nameFieldValidator(true, 75)]
                    }}
                  />
                  <TextField
                    className="CreateInformationForm__Field"
                    form={form}
                    fieldId="lastname"
                    initialValue={userInformation.lastName}
                    placeholder={t('FIELDS:last-name')}
                    fieldOptions={{
                      rules: [...nameFieldValidator(true, 75)]
                    }}
                  />
                </div>
              </React.Fragment>
            )}

            {(this.props.organization.typeId === 2 &&
              isPluginActive(platform, 'TaxReceipt') && (
                <Plugin
                  name="TaxReceipt"
                  component="PublicInformationFields"
                  resolve={() =>
                    import(
                      /* webpackChunkName: "TaxReceipt" */ '../../../TaxReceipt/TaxReceipt.jsx'
                    )
                  }
                  {...{
                    form: form,
                    provinces: this.props.provinces,
                    locale: locale,
                    organization: isCorporate,
                    savedValues: {
                      province: userInformation.province,
                      address: userInformation.address,
                      unit: userInformation.unit,
                      city: userInformation.city
                    },
                    dropdownClassName: 'overModal'
                  }}
                />
              )) || (
              <React.Fragment>
                <div className="CreateInformationForm__Divider AddressUnit">
                  <AddressField
                    className="CreateInformationForm__Field"
                    form={form}
                    label={false}
                    placeholder={true}
                    required={true}
                    initialValue={userInformation.address || undefined}
                    identity={isCorporate ? 'company' : 'user'}
                  />
                  <UnitField
                    className="CreateInformationForm__Field"
                    form={form}
                    label={false}
                    placeholder={true}
                    initialValue={userInformation.unit || undefined}
                    identity={isCorporate ? 'company' : 'user'}
                  />
                </div>
                <div className="CreateInformationForm__Divider CityProvince">
                  <CityField
                    className="CreateInformationForm__Field"
                    form={form}
                    label={false}
                    placeholder={true}
                    required={true}
                    initialValue={userInformation.city || undefined}
                    identity={isCorporate ? 'company' : 'user'}
                  />
                  <ProvinceField
                    className="CreateInformationForm__Field"
                    dropdownClassName="overModal"
                    form={form}
                    provinces={this.props.provinces}
                    locale={locale}
                    label={false}
                    placeholder={true}
                    required={
                      form.getFieldValue('country') === 'CA' ||
                      form.getFieldValue('country') === 'US'
                    }
                    initialValue={userInformation.province || undefined}
                    identity={isCorporate ? 'company' : 'user'}
                  />
                </div>
              </React.Fragment>
            )}
            <div className="CreateInformationForm__Divider">
              <PostalCodeField
                className="CreateInformationForm__Field"
                form={form}
                initialValue={userInformation.postalCode}
                label={false}
                placeholder={true}
                required={true}
                country={this.state.country}
                identity={isCorporate ? 'company' : 'user'}
              />
            </div>
            <div className="CreateInformationForm__Divider">
              <Form.Item
                className='NumberField CreateInformationForm__Field'
                hasFeedback
              >
                {form.getFieldDecorator('number', {
                  initialValue: this.unformatPhoneNumber(userInformation.phone),
                  rules: [
                    {
                      required: true,
                      message: t('phone-required')
                    },
                    {
                      pattern: /^(?:1)?[0-9]{3}[0-9]{3}[0-9]{4}$/,
                      message: t('phone-invalid')
                    }
                  ]
                })(
                  <InputNumber
                    placeholder={t('phone')}
                    parser={value => {
                      return this.unformatPhoneNumber(value)
                    }}
                    formatter={value => {
                      if (value.length <= 4) {
                        return value;
                      } else
                      if (value.length <= 7) {
                        return value.substring(0, 3) + '-' + value.substring(3);
                      } else
                      if (value.length <= 10) {
                        return value.substring(0, 3) + '-' + value.substring(3, 6) + '-' + value.substring(6);
                      } else
                      if (value.length > 10) {
                        const countryLength = value.length - 10;
                        return value.substring(0, countryLength) + '-' +
                              value.substring(countryLength, countryLength + 3) + '-' +
                              value.substring(countryLength + 3, countryLength + 6) + '-' +
                              value.substring(countryLength + 6);
                      } else {
                        return value;
                      }
                    }}
                  />
                )}
              </Form.Item>
            </div>
            <div className="CreateInformationForm__Divider">
              <TextField
                form={form}
                className="CreateInformationForm__Field"
                placeholder={t('extension')}
                fieldId={'ext'}
                initialValue={userInformation.ext}
              />
            </div>
            <p>{t('preferred-language')}</p>
            <div className="CreateInformationForm__Divider">
              <LanguageField
                className="CreateInformationForm__Field"
                form={form}
                savedValue={defaultLocale}
                dropdownClassName="overModal"
              />
            </div>
          </Form>
        </FundkyModal>
      </div>
    );
  }
}

UserInformationCards.defaultProps = {
  isCorporate: false
};

UserInformationCards.propTypes = {
  form: PropTypes.object.isRequired,
  //storeUserInformation: PropTypes.func.isRequired,
  history: PropTypes.object,
  isCorporate: PropTypes.bool
};

export default translate('UserInformationCards')(UserInformationCards);
